module.exports = __webpack_public_path__ + "img/85_11.79b0efb6.png";